/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react';
import { withPermissionsProps } from '../../Utilities/hoc/withPermissions';
import { ISmartProps } from './types';
import { View } from './view';

export type TabsProps = ISmartProps & withPermissionsProps;

export const Tabs = React.forwardRef((props: TabsProps, ref: any) => {
	// When 'onChange' prop is fully deprecated onTabChange & onChange override can be removed
	return <View {...props} onTabChange={props.onTabChange || props.onChange} onChange={undefined} ref={ref} />;
});
